import React, { useCallback, useContext, useEffect, useState } from 'react'
import ChatBox from '../component/ChatBox'
import { SocketContext, UserContext } from '../context/UserContext';
import { useParams } from 'react-router-dom';
import { callAPI } from '../helper/apiHelper';
import { API_URL_ENDPOINT, BASE_URL } from '../appsetting/appsetting';
import Header from '../component/Header';
import Seats from '../component/Seats';
import Footer from '../component/Footer';
import { Offcanvas } from 'react-bootstrap';

const Live = () => {
    const [room, setRoom] = useState(null)
    const [seatLayout, setSeatLayout] = useState([])
    const { globalUser, updateUser,  login } = useContext(UserContext);
    const { socket } = useContext(SocketContext)
    const { id } = useParams();
    const [isHostOnASeat, setIsHostOnASeat] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [isCallStart, setIsCallStart] = useState(false)
    const [userMessage, setUserMessage] = useState('Please Wait...');
    const [liveMembers, setLiveMembers] = useState([])
    const usertoken = id.split('::')[1];

    useEffect(()=>{
        const roomID = id.split('::')[0];
        FindRoomByID(roomID);
    },[])

    useEffect(() => {
      // Define the global function to receive messages
      window.receiveMessageFromReactNative = (message) => {
        console.log("Message from React Native:", message);
        handleEndCall(globalUser?.isHost,"")
        // Handle the message as needed
      };
    }, []);

    useEffect(()=>{
      if (!socket || !globalUser || !room) return;
      socket.emit('joinRoom', {roomId : room?.RoomID, userID : globalUser.ID});
      setIsCallStart(true);
      const isMainHost = seatLayout[0]?.UserID === globalUser?.ID;
      setIsHostOnASeat(isMainHost)

      socket.on('MettingEnd', handleEndMetting)

      return () => {
        socket.off('MettingEnd')
      }
    },[socket, globalUser, room])

    const handleEndMetting = () => {
      setIsCallStart(false)
      setUserMessage('Metting Ended.')
      socket.disconnect();
    }

    const fetchMember = async (rid = null) =>{
      try{
        const response = await callAPI(BASE_URL + API_URL_ENDPOINT.GET_LIVE_MEMBERS + "?roomID="+rid ?? room?.RoomID);
        if(response?.status){
          if(response?.data?.length>0){
            setLiveMembers(response.data)
            localStorage.setItem("liveMembers", JSON.stringify(response.data));
          }
        }else{
          throw new Error(response?.message || "No Request Found")
        }
      }catch(error){
        setLiveMembers([])
      }
    }

    const FindRoomByID = async (roomToken) =>{
      try{
        const response = await callAPI(BASE_URL + API_URL_ENDPOINT.FIND_ROOM_BY_ID + `?roomID=${roomToken}`);
        if(response?.data && response?.status){
          await fetchMember(response?.data?.RoomID)
          await FindUserByToken(usertoken, response?.data?.RoomID);
          setTimeout(() => {
            setRoom(response.data)
            setSeatLayout(response.data.seat);
          }, 1000);
          // setTotalParticipate(response.data.TotalParticipate);
        }else{
          throw new Error(response?.message || "Invalid Room")
        }
      }catch(error){
          setUserMessage(error.message ?? 'No Metting Found.')
          setIsCallStart(false)
      }finally{

      }
    }

    const FindUserByToken = async (userToken, roomID) =>{
      try{
        const response = await callAPI(BASE_URL + API_URL_ENDPOINT.FIND_USER_BY_TOKEN + `?token=${userToken}&room=${roomID}`);
        if(response?.data && response?.status){
          login(response.data)
        } else {
          throw new Error(response?.message  || 'No User Found')
        }
      }catch(error){
        setUserMessage(error.message ?? 'Something Went Wrong.')
        setIsCallStart(false);
      }finally{

      }
    }

    const handleEndCall = useCallback((isHost, action) =>{
      console.log("End Call Called", isHost,"ac", action)
      if(isHost && action == ""){
        setShowConfirm(true);
        return;
      }
      if(isHost && action === "END_METTING"){
        socket.emit("MettingEnd", ({roomID:room?.roomID}))
        setShowConfirm(false)
        setUserMessage('Metting Ended.')
        setIsCallStart(false)
        return;
      }

      socket.emit("ProducerDisconnected", ({userID:globalUser?.ID}))
      setShowConfirm(false)
      setUserMessage('Metting Ended.')
      setIsCallStart(false)
      window.ReactNativeWebView?.postMessage("END_CALL");
    },[socket])

    const handleGoToHome = () => {
      window.ReactNativeWebView?.postMessage("END_CALL");
    }
  return (
    <>
      <div style={{height:'100vh', background:'#474338'}} className='d-flex flex-column'>
          {/* {console.log("Layout Ready", seatLayout)} */}
          {(isCallStart && seatLayout)?
            <>
            <div className='container-fluid'>
              <Header room={room} liveMembers={liveMembers} getLivemember={fetchMember}/>
              <Seats room={room} seatLayout={seatLayout}/>
              <Footer room={room} isHostOnASeat={isHostOnASeat} handleEndCall={handleEndCall}/> 
            </div>
            <ChatBox/>
            </>
          : 
          <div className='card m-4 shadow p-4'>
             <div className='text-danger'>{userMessage ?? "No Metting Found"}</div>
             {(userMessage == "Please Wait...") ? "" : <button onClick={handleGoToHome} className='btn btn-dark shadow-none mt-4'>Go To Home</button>}
          </div>
          }
      </div>

      <Offcanvas className='rounded-top h-auto' show={showConfirm} onHide={() => setShowConfirm(false)} placement="bottom">
        <Offcanvas.Header className=' border-bottom'>
          <Offcanvas.Title className='text-center w-100'>Confirm End Call</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <>
            <button onClick={() => handleEndCall(globalUser?.isHost, "END_CALL")} className='btn btn-danger w-100 mb-3 shadow-none'>
            <i className="bi bi-telephone-fill me-2"></i>End Your Call
            </button>
            <button onClick={() => handleEndCall(globalUser?.isHost, "END_METTING")} className='btn btn-danger w-100 mb-1 shadow-none'>
            <i className="bi bi-telephone-fill me-2"></i> End Metting
            </button>
          </>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default Live